import React, {Children, cloneElement, isValidElement, Suspense} from 'react';
import {connect, useDispatch, useSelector} from 'react-redux'
import AppHeader from "../components/common/AppHeader/AppHeader";
import AppFooter from "../components/common/AppFooter/AppFooter";
import {useLocation} from "react-router";
import Loader from "../components/common/Loader/Loader";
import {Redirect} from "react-router-dom";
import AemConfigurations from "../helpers/aemConfigurations";
import {UserRoleEnum} from "../helpers/enums";
import {SwitchUser} from "../helpers/helpers";

const mapStateToProps = (state, ownProps) => {
  const {isLoading, isLoadingText, isLoadingAmount} = state.app;
  const {user, profile} = state.auth;
  return {
    logged: state.auth.user !== null,
    user,
    profile,
    isLoading,
    isLoadingText,
    isLoadingAmount,
  }
};
const mapDispatchToProps = (dispatch, ownProps) => {
  return {}
};

const Page = (props) => {
  let location = useLocation();
  let dispatch = useDispatch();
  const auth = useSelector((state) => state.auth);

  const isMaintenance = AemConfigurations.get('maintenance') || false;

  const childrenWithProps = Children.map(props.children, child => {
    if (isValidElement(child)) {
      return cloneElement(child, {dispatch})
    }
    return child;
  });

  const currentPage = location.pathname.replace('/', '');

  let role = props.profile ? props.profile.role : null;
  if (role) {
    if (auth) {
      const {impersonationActive} = auth;
      if (impersonationActive) {
        const user = SwitchUser(auth);
        if (user) {
          const {role: currentRole = null} = user;
          role = currentRole;
        }
      }
    }
  }
  const isRouteAccessibleByUser = (role, route) => {
    const permissions = {
      '/soci': [UserRoleEnum.PARTNER],
      '/soci-documents': [UserRoleEnum.PARTNER],
      "/register-operators": [UserRoleEnum.MANAGER],
      "/contracts/dissociate": [UserRoleEnum.PRIVATE, UserRoleEnum.COMPANY]
    }

    if (permissions[route]) {
      if (!permissions[route].includes(role)) {
        return false;
      }
    }

    return true;
  }

  if (role !== null) {
    if (!isRouteAccessibleByUser(role, location.pathname)) {
      return <Redirect to={'/dashboard'}/>
    }
  }
  const regex = '(maintenance)|(embed-cases\\/.*)|(index.html)';
  const found = currentPage.match(regex) || null;
  if (isMaintenance && !found) {
    return <Redirect to={'/maintenance'}/>
  }

  // Chat Layout
  if (location.pathname.indexOf('chat') > 0) {
    return (
      <div>
        {childrenWithProps}
      </div>
    )
  }

  // Embed cases Layout
  const embedUrls = [
    'embed-cases',
    'tool-amministratori-condominio'
  ];
  const hasEmbedUrl = location => {
    let shouldBeExcluded = false;
    for (let index in embedUrls) {
      if (location.indexOf(embedUrls[index]) !== -1) {
        shouldBeExcluded = true;
      }
    }
    return shouldBeExcluded;
  }
  if (hasEmbedUrl(location.pathname)) {
    return (
      <div className="App page container-fluid">
        {
          <Loader className={props.isLoading ? '' : 'invisible'} text={props.isLoadingText}
                  amount={props.isLoadingAmount}/>
        }
        <Suspense fallback="props.isLoading">
          <div>
            {childrenWithProps}
          </div>
        </Suspense>
      </div>
    )
  }

  return (
    <div className="App page container-fluid">
      {
        <Loader className={props.isLoading ? '' : 'invisible'} text={props.isLoadingText}
                amount={props.isLoadingAmount}/>
      }

      <Suspense fallback="props.isLoading">
        <AppHeader/>
          <main id="main">
            {
              currentPage === 'login' ? (
                <div className={"d-flex flex-row justify-content-center align-items-center"}>
                  <div className="App page container-fluid">
                    {childrenWithProps}
                  </div>
                </div>
              ) : (
                <div>
                  {childrenWithProps}
                </div>
              )
            }
          </main>
        <AppFooter/>
      </Suspense>

    </div>
  )
}

const LayoutContainer = connect(mapStateToProps, mapDispatchToProps)(Page)

export default LayoutContainer
